'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './preferences.routes';

export class PreferencesComponent {
  constructor(Config, Auth, User, dialogs) {
    'ngInject';

    this.Auth = Auth;
    this.User = User;
    this.dialogs = dialogs;

    this.user = Auth.getCurrentUserSync();
  }

  save() {
    this.Auth.updateUser(this.user);

    this.dialogs.notify("Success", "The changes have been saved.");
  }
}

export default angular.module('conduuApp.preferences', [uiRouter])
  .config(routes)
  .component('preferences', {
    template: require('./preferences.html'),
    controller: PreferencesComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/preferences/preferences.component.js